<template>
  <span style="position: relative;top: -3px;">
    <i 
      v-for="n in Math.floor(stars)"  
      :key="n" 
      :style="{color: color}"
      class="fas fa-star mr-1" 
      :title="stars + ' ' + (stars === 1 ? 'star' : 'stars')">
    </i>
  </span>
</template>

<script>
export default {
  props: ['stars','color']
};
</script>
